var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('star-rating',{attrs:{"rating":parseInt(_vm.value),"read-only":true,"increment":0.01,"star-size":20,"show-rating":false}})}
var staticRenderFns = []

export { render, staticRenderFns }